/**
 * Cleanup script for multi-review carousel widget
 * Removes empty widgets when there are no reviews and it's not a preview
 * This script runs inside the iframe
 */

/**
 * This should be called when the widget determines it has no content to display
 */
export function cleanupEmptyWidget(instanceId: number): void {
    const removalMessage = {
        type: 'rma-markup-cleanup',
        widgetId: instanceId // This ID should be known by the parent
    };
    // Send the message to the parent window.
    // Using a specific origin is more secure than '*', but '*' will work for now.
    window.parent.postMessage(removalMessage, '*');
}

/**
 * Initialize cleanup check on page load
 * This is called from the Razor view
 */
export function initializeCleanup(instanceId: number): void {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            cleanupEmptyWidget(instanceId);
        });
    } else {
        cleanupEmptyWidget(instanceId);
    }
}
